import "./ListOneDemocraticParty.module.css";
import Header from "@/reusable_sections/Header";
import CandidatesList1 from "./sections/CandidatesList1";
import Footer from "@/reusable_sections/Footer";
export default function ListOneDemocraticPartyPage() {
  return <div className='min-h-screen flex flex-col'>
      <Header />
      <CandidatesList1 />
      <Footer />
    </div>;
}